import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ThemeService, TranslationService } from '@concretecode/data';
import { DarkModeToggle, LanguageSwitcher } from '@concretecode/ui-pure';
import { Language } from '@concretecode/shared';

@Component({
  selector: 'app-header',
  imports: [DarkModeToggle, LanguageSwitcher],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  readonly #themeService = inject(ThemeService);
  readonly #translationService = inject(TranslationService);
  public readonly title = input<string | null>('');
  protected readonly currentLanguage = this.#translationService.getLanguage();
  protected readonly isDark = this.#themeService.isDark;

  protected languageChanged(language: Language): void {
    void this.#translationService.setLanguage(language);
  }
}
